import React, { useCallback } from 'react'

import { useDispatch } from 'react-redux'

import { trackUTMAndPromoCode } from 'actions/tracking'
import { dismissRecipesInBasketProgress } from 'actions/trackingKeys'

import { useBasket } from '../../domains/basket'
import { RecipesInBasketProgressPresentation } from './RecipesInBasketProgress.presentation'

type CloseTrackingFn = (maxRecipes: number, percentage: number) => void

function useTracking() {
  const { recipeCount } = useBasket()
  const dispatch = useDispatch()
  const dispatchTrackUTMAndPromoCode = useCallback<CloseTrackingFn>(
    (maxRecipes, percentage) => {
      dispatch(
        trackUTMAndPromoCode(dismissRecipesInBasketProgress, {
          num_recipes: recipeCount,
          max_recipes: maxRecipes,
          percentage_complete: percentage,
        }),
      )
    },
    [recipeCount, dispatch],
  )

  return { dispatchTrackUTMAndPromoCode, recipeCount }
}

const RecipesInBasketProgress = () => {
  const { dispatchTrackUTMAndPromoCode, recipeCount } = useTracking()

  return (
    <RecipesInBasketProgressPresentation
      selectedRecipesCount={recipeCount}
      onClose={dispatchTrackUTMAndPromoCode}
    />
  )
}

export { RecipesInBasketProgress }
